module.exports = __webpack_public_path__ + "static/default-b54d9933c8500126c3472b2296f0fac8.svg";